var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBentArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "bentArrow",
    width: "100%",
    height: "100%",
    viewBox: "0 0 63 64",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-924,-618)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,975.934,680.363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.973,-9.974L-19.947,-9.974L-19.947,0L9.973,0L9.973,-9.974Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,965.96,670.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-39.9L0,-29.92L-9.97,-29.92L-9.97,0L-19.95,0L-19.95,-29.92L-29.92,-29.92L-29.92,-39.9L-19.95,-39.9L-19.95,-29.93L-9.97,-29.93L-9.97,-39.9L0,-39.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1902,171.014)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 946.013,
    y: 449.506,
    width: 9.974,
    height: 9.974
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,210.91)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 926.066,
    y: 429.558,
    width: 9.974,
    height: 9.974
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,210.91)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 965.961,
    y: 429.558,
    width: 9.974,
    height: 9.974
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBentArrow);
export default __webpack_public_path__ + "static/media/bentArrow.956908d9.svg";
export { ForwardRef as ReactComponent };